import { ApplicationDbService } from '@shared/services/application-db.service'
import { BaseDbServicesWrapper } from '@app/shared/services/db/base-db-services-wrapper';

import { Injectable } from '@angular/core';
import { IUserSubscribedTags, UserSubscribedTagsSerializer } from '@koomzo/coremodel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSubscribedTagsDbService extends ApplicationDbService <IUserSubscribedTags> {
  
  constructor(baseDbServicesWrapper: BaseDbServicesWrapper<IUserSubscribedTags>) {
    super(baseDbServicesWrapper, new UserSubscribedTagsSerializer(),'usersubscribed-tags');
  }

  getUserSubscribedTags(id:string):Observable<IUserSubscribedTags>{
    return this.getById(id)
  }
}
